// React imports.
import React, { Component } from "react";
const DataCategories = ({ fieldCategories, selectedCategoryId, setSelectedCategoryId }) => (
  <div className="verticalList" >
    {fieldCategories
      .map(field => {

        return (
          <nav key={field.categoryId} className={"navbar bg-light " + (field.categoryId == selectedCategoryId ? "selectedListItem":"") }>
            <a href="#" onClick={e => { setSelectedCategoryId(e, field.categoryId) }}>{field.categoryName}</a>
          </nav>
        );
    })}
  </div>
);

export default DataCategories;
